export const CUSTOMER_ORDERS = /* GraphQL */ `
    query customer($pageSize: Int, $currentPage: Int) {
        customer {
            firstname
            lastname
            orders(pageSize: $pageSize, currentPage: $currentPage) {
                page_info {
                    current_page
                    page_size
                    total_pages
                }
                total_count
                items {
                    number
                    id
                    order_date
                    total {
                        grand_total {
                            value
                            currency
                        }
                    }
                    items {
                        product_sku
                        product_name
                        product_type
                        product_url_key
                        id
                        status
                    }
                    status
                    shipping_address {
                        firstname
                        lastname
                    }
                }
            }
        }
    }
`
